import React, { useState,useEffect } from 'react';
import Footer from '../layout/footer';
import inner_line from '../assets/images/inner_line.png'
import {getCmsContent} from '../actions/axios/useaxios'
import HeaderOne from '../layout/HeaderOne';

export default function Privacy() {
  const [term,setterms]=useState()

  useEffect(() => {
    termsandservice();
  }, [])

  const termsandservice = async () => {
    var resp = await getCmsContent({data:"termsofservice"});
    if (resp?.status) setterms(resp?.data);
  };
  return (
    <div className='inner_pages'>
      <HeaderOne />
      <div className='cms_pages'>
        <div className='inner_sec'>

          <div className='container inner_container'>


            <div className='top_sec'>
              <div className='row'>
                <div className='text-center mb-4'>
                  <p className='page_title imfell_font'>Terms of services</p>
                  <img src={inner_line} alt='inner_border' className='img-fluid' width={120} />
                </div>
                <div className='desc_sec'>
                </div>
              </div>

            </div>
          <div className='cms_content_sec'>
         
            <ul>
              <li>
                <p className='desc averia_font' dangerouslySetInnerHTML={{__html:term?.answer}}></p>
              </li>
               
            </ul>
               
          </div>
           
           
          </div>


        </div>
      </div>


      <Footer />

    </div>
  )
}
